module.exports = __webpack_public_path__ + "static/media/food-chain-grapes-mobile.a4d85f3f.jpg";